import classnames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'

import { chainDecorators, memoized } from '../../utils/ReactUtils'

import styles from './styles'


const decorators = [
  memoized,
]

function Layout(props) {
  const { children } = props

  return (
    <main className={classnames('layout')}>
      {children}
      <style jsx>{styles}</style>
    </main>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

Layout = chainDecorators(decorators, Layout)

export default Layout
